import axios from "axios";
import * as API_LINKS from '../../../configurations/links.jsx'
import {toast} from 'react-toastify';
import cookie from 'react-cookies'

export const FETCH_ORGANIZATION_LIST = 'FETCH_ORGANIZATION_LIST'
export const RECEIVE_ORGANIZATION_LIST = 'RECEIVE_ORGANIZATION_LIST'
export const FAILED_ORGANIZATION_LIST = 'FAILED_ORGANIZATION_LIST'


export function fetchOrganizationList(_data){
    
    return (dispatch, getState) => {
        dispatch({type: FETCH_ORGANIZATION_LIST});
        axios({
            method: 'post',
            url: API_LINKS.GET_ORGANIZATION,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
             if(response.status === 200) {
                if(response.data.status === "success") {
                    dispatch( {
                        type: RECEIVE_ORGANIZATION_LIST,
                        payload: response.data.result
                    })
                   
                } else {
                    dispatch({
                        type: FAILED_ORGANIZATION_LIST
                    })
                    return toast.error(response.data.message);
                }
            } else {
                dispatch({
                    type: FAILED_ORGANIZATION_LIST
                })
                return toast.error(response.data.message);
            }
        })
        .catch(function(error){
            if (error.response){
                dispatch({
                    type: FAILED_ORGANIZATION_LIST
                })
                return toast.error(error.response.data.message);;
            }
        }
        )
        }
    }



// WEBPACK FOOTER //
// ./src/redux/actions/satuan/aSatuan-GetOrganization.jsx